export default "__VITE_ASSET__B9e7k0sV__"